
import { Component, Input, OnInit } from '@angular/core';
import {
    LoadingController,
    NavController,
    NavParams,
    ToastController
} from 'ionic-angular';
import { ApiService } from '../../../../services/api';
import { Rodeo } from '../../../../model/rodeo';
import { Sidepot } from '../../../../model/sidepot';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { ReportsService } from '../../../../services/reports.service';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'staff-payment-plans-report',
    templateUrl: 'report-payment-plans.html'

})
export class PaymentPlansReport implements OnInit {
    @Input('rodeo') rodeo: Rodeo
    @Input('viewMode') viewMode: string;

    report: { 
        checks: any[],
        paymentPlans: any[]
    };

    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    constructor(private nav: NavController, private currency: CurrencyPipe, private toast: ToastController, private navParams: NavParams, public api: ApiService, private reportService: ReportsService, private loadingControl: LoadingController) {
    }

    async ngOnInit() {
        if (!this.rodeo)
            this.rodeo = this.navParams.get('rodeo');

        this.printing = this.navParams.get('printing');

        let loading = this.loadingControl.create({
            content: 'Loading transactions...',
        });

        loading.present();
        try {
            this.report = await this.reportService.getPaymentPlans(this.rodeo.id) as any;
            console.log(this.report);   
        } catch (err) {
            this.toast.create({ message: 'Something went wrong.', duration: 2500}).present();
        }
        this.dataLoaded = true;
        loading.dismiss();
    }


    private mapReport(item) {
        return {
            'Payment Id': item.id,
            'Customer': `${item.account.firstName} ${item.account.lastName}`,
            'Customer Email': item.receiptEmail,
            'Created On': new Date(item.createdOn).toDateString(),
            'Purchase Description': item.lineItems.map(x => x.description || x.displayName).join(', '),
            'Amount Charged By Secretary': this.currency.transform(item.totalAmountCollectedBySecretary),
            'Amount Charged By NextGen': this.currency.transform(item.totalAmountCollectedByNextGen),
            'Amount Charged To Customer': this.currency.transform(item.totalCharged),
            'Amount Paid': this.currency.transform(item.amountPaid),
            'Amount Remaining': this.currency.transform(item.amountRemaining),
            'Due By': new Date(item.payments[item.payments.length - 1].dueOn).toDateString(),
            'Paid On': item.completedOn ? new Date(item.completedOn).toDateString() : null,
            'Payment Method': item.paymentMethod,
        }
    }

    download() {
        
        const checks = this.report.checks.map(item => this.mapReport(item));

        const plans = this.report.paymentPlans.map(item => this.mapReport(item));

        //overview report
        const report = [...checks, ...plans];

        //itemized report showing payment plan installments
        const checkPayments = this.report.checks.flatMap(x => x.payments);
        const planPayments = this.report.paymentPlans.flatMap(x => x.payments);
        const payments = [...checkPayments, ...planPayments];
        console.log({payments});
        //need a different map here

        this.reportService.exportToCsv(report, `Checks and PaymentPlans - ${this.rodeo.name}`);
    }

    //each of these actions will be a button at the top
    //rows should be selectable
    //maye need to show entry information?
    
    notifyRopers() {
        //select all button    
    }

    turnoutEntries() {
        //select all button
    }

    markAsPaid() {
        
    }





    // ionViewDidEnter() {
    //     setTimeout(() => {
    //         window.document.title = this.documentTitle;
    //         window.print();
    //         this.nav.pop();
    //     }, 0);
    // }

    // print() {
    //     if (this.popoverActive)
    //         return;

    //     this.popoverActive = true;

    //     this.nav.push(PaymentPlansReport, {
    //         rodeo: this.rodeo,
    //         printing: true,
    //     }).then(() => { this.popoverActive = false; });
    // }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-payment-plans.ts